import { useMemo } from "react";
import Form from "V2.0/components/Form";
import { getAssistantTransferAgentFields } from "./getAssistantTransferAgentFields";

function AssistantAgentForm(props) {
  const {
    defaultAssistantAgent,
    assistantOptions,
    onSubmit,
    onCancel,
    loading,
    setLoading,
    buttonInfo,
  } = props;

  const { template, schema } = useMemo(
    () => getAssistantTransferAgentFields(assistantOptions),
    [assistantOptions]
  );

  const inputField = {
    name: defaultAssistantAgent?.name ?? "",
    assistantId: defaultAssistantAgent?.assistantId ?? "",
    trigger: defaultAssistantAgent?.trigger ?? "",
    dynamicWelcomeMessageEnabled:
      defaultAssistantAgent?.dynamicWelcomeMessageEnabled ?? false,
  };

  return (
    <Form
      template={template}
      schema={schema}
      inputField={inputField}
      onSubmit={onSubmit}
      handleSecondary={onCancel}
      loading={loading}
      setLoading={setLoading}
      buttonInfo={buttonInfo}
    />
  );
}

export { AssistantAgentForm };
